import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { deepEqual } from '../utils';

class DriversToolbar extends Component {
  constructor(props) {
    super(props);
    this.onSearchInput = this.onSearchInput.bind(this);
  }
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  onSearchInput(ev) {
    this.props.onSearchInput(ev.target.value);
  }

  getStatusText() {
    if (this.props.isSearching) {
      return 'Buscando...';
    }

    if (this.props.count > 0) {
      return `Mostrando ${this.props.count} motorista${this.props.count !== 1 ? 's' : ''}`;
    }

    return '';
  }

  render() {
    return (
      <div className="filter" style={{ display: 'flex' }}>
        <a
          className="button button-default button-icon"
          style={{ flex: 'initial', marginRight: '10px' }}
          onClick={this.props.onAddClick}
          onKeyPress={this.props.onAddClick}
          role="button"
          tabIndex={0}
        >
          <i className="md-icon">add</i>
        </a>
        <input
          type="text"
          className="form-control"
          placeholder="Buscar motoristas..."
          value={this.props.searchTerm}
          onInput={this.onSearchInput}
          style={{ flex: 'auto' }}
        />

        <div style={{ flex: 'initial', margin: '0px 10px' }}>
          {this.getStatusText()}
        </div>

        {this.props.isAdmin && (
          <a
            className="button button-default button-icon"
            style={{ flex: 'initial', marginRight: '10px' }}
            onClick={this.props.onRecalculateClick}
            onKeyPress={this.props.onRecalculateClick}
            role="button"
            tabIndex={0}
          >
            <i className="md-icon">gavel</i>
          </a>
        )}
        <a
          className="button button-default button-icon"
          style={{ flex: 'initial', marginRight: '10px' }}
          onClick={this.props.onWorkedDaysReportClick}
          onKeyPress={this.props.onWorkedDaysReportClick}
          role="button"
          tabIndex={0}
        >
          <i className="md-icon">date_range</i>
        </a>
        <a
          className="button button-default button-icon"
          style={{ flex: 'initial', marginRight: '10px' }}
          onClick={this.props.onAvailableDaysReportClick}
          onKeyPress={this.props.onAvailableDaysReportClick}
          role="button"
          tabIndex={0}
        >
          <i className="md-icon">date_range</i>
        </a>
      </div>
    );
  }
}

DriversToolbar.propTypes = {
  count: PropTypes.number,
  searchTerm: PropTypes.string,
  onSearchInput: PropTypes.func,
  isSearching: PropTypes.bool,
  // eslint-disable-next-line
  onAddClick: PropTypes.func,
  onWorkedDaysReportClick: PropTypes.func,
  onAvailableDaysReportClick: PropTypes.func,
  onRecalculateClick: PropTypes.func,
  isAdmin: PropTypes.bool,
};

DriversToolbar.defaultProps = {
  count: null,
  searchTerm: '',
  isSearching: false,
  onSearchInput: () => {},
  onAddClick: () => {},
  onWorkedDaysReportClick: () => {},
  onAvailableDaysReportClick: () => {},
  onRecalculateClick: () => {},
  isAdmin: false,
};

const mapStateToProps = ({ authState: { currentUser } }) => ({
  isAdmin: (currentUser && currentUser.rule === 'admin'),
});

export default connect(mapStateToProps)(DriversToolbar);



// WEBPACK FOOTER //
// ./src/Driver/DriversToolbar.js